var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgHDots = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1984 5.60156C11.9705 5.60156 12.5984 6.22946 12.5984 7.00156C12.5984 7.77366 11.9705 8.40156 11.1984 8.40156C10.4263 8.40156 9.79844 7.77366 9.79844 7.00156C9.79844 6.22946 10.4263 5.60156 11.1984 5.60156ZM6.99844 5.60156C7.77054 5.60156 8.39844 6.22946 8.39844 7.00156C8.39844 7.77366 7.77054 8.40156 6.99844 8.40156C6.22634 8.40156 5.59844 7.77366 5.59844 7.00156C5.59844 6.22946 6.22634 5.60156 6.99844 5.60156ZM2.79844 5.60156C3.57054 5.60156 4.19844 6.22946 4.19844 7.00156C4.19844 7.77366 3.57054 8.40156 2.79844 8.40156C2.02634 8.40156 1.39844 7.77366 1.39844 7.00156C1.39844 6.22946 2.02634 5.60156 2.79844 5.60156Z",
    fill: "#8C9196"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHDots, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/h-dots.b16eb50a.svg";
export { ForwardRef as ReactComponent };